import { defineMessages } from 'react-intl';

import {
  ORDER_SHIPMENT,
  RECIPIENT,
  RECIPIENT_NAME,
  RECIPIENT_COMPANY,
  RECIPIENT_NAME_AND_COMPANY,
  RECIPIENT_ADDRESS,
  RECIPIENT_ADDRESS_FULL_COUNTRY,
  RECIPIENT_PHONE,
  RECIPIENT_EMAIL,
  STORE,
  STORE_LOGO,
  STORE_NAME,
  STORE_COMPANY_NAME,
  STORE_PHONE,
  STORE_EMAIL,
  STORE_WEBSITE,
  ORDER_NUMBER,
  SCAN_ORDER_NUMBER,
  IMPORT_KEY,
  ORDER_ID,
  CURRENT_DATE,
  SHIP_DATE,
  ORDER_DATE,
  PAYMENT_DATE,
  CARRIER_NAME,
  CARRIER_FEE,
  PACKAGE_TYPE,
  SHIPPING_SERVICE,
  SHIPPING_PAID,
  TAX_PAID,
  AMOUNT_PAID,
  REQUESTED_SHIPPING_SERVICE,
  EXTENDED_PRICE,
  EXTENDED_PRICE_ZERO,
  ADJUSTMENT,
  ORDER_TOTAL,
  DIMENSIONS,
  WEIGHT,
  TRACKING_NUMBER,
  TRACKING_URL,
  ITEM_LIST,
  ITEM_LIST_IMAGES,
  ITEM_LIST_NOSKU,
  ITEM_LIST_HIDEZERO,
  ITEM_LIST_SHOWOPTIONS,
  ITEM_LIST_EXTERNALID,
  ITEM_LIST_SHOWCOST,
  ITEMS_TOTAL,
  TOTAL_QUANTITY,
  TOTAL_QUANTITY_WITHOUT_ADJUSTMENTS,
  TOTAL_QUANTITY_WITHOUT_ADJUSTMENTS_AND_ZERODOLLARITEMS,
  TOTAL_QUANTITY_WITHOUT_ZERODOLLARITEM,
  BUYER_NAME,
  USERNAME,
  NOTES_TO_BUYER,
  NOTES_FROM_BUYER,
  GIFT_MESSAGE,
  PACKING_SLIP_MESSAGE,
  SHIP_FROM,
  SHIP_FROM_ADDRESS,
  SHIP_FROM_COMPANY,
  SHIP_FROM_COUNTRY,
  WAREHOUSE_LOCATION,
  SHIP_FROM_NAME,
  CUSTOM_FIELD_1,
  CUSTOM_FIELD_2,
  CUSTOM_FIELD_3,
  INTERNAL_NOTES,
  USPS_ZONE,
  PRODUCT,
  PRODUCT_NAME,
  QUANTITY,
  SKU,
  UPC,
  IMAGE_URL,
  UNIT_PRICE,
  ITEM_TITLE,
  MARKETPLACE_ITEM_NUMBER,
  ASIN,
  FILL_SKU,
  ITEM_OPTIONS,
  ITEM_OPTIONS_LINEBREAK,
  ITEM_OPTIONS_WITHOUT_REPLACEMENT,
  PRODUCT_DESCRIPTION,
  PRODUCT_LOCATION,
  PRODUCT_SKU,
  SHIP_BY_DATE,
} from './constants';

export const supportedInPackingSlips = {
  [ORDER_SHIPMENT]: [
    ADJUSTMENT,
    AMOUNT_PAID,
    BUYER_NAME,
    CARRIER_FEE,
    CARRIER_NAME,
    CURRENT_DATE,
    CUSTOM_FIELD_1,
    CUSTOM_FIELD_2,
    CUSTOM_FIELD_3,
    DIMENSIONS,
    IMPORT_KEY,
    GIFT_MESSAGE,
    INTERNAL_NOTES,
    ITEMS_TOTAL,
    NOTES_FROM_BUYER,
    NOTES_TO_BUYER,
    ORDER_NUMBER,
    ORDER_DATE,
    ORDER_ID,
    ORDER_TOTAL,
    PACKAGE_TYPE,
    PACKING_SLIP_MESSAGE,
    PAYMENT_DATE,
    REQUESTED_SHIPPING_SERVICE,
    SCAN_ORDER_NUMBER,
    SHIP_BY_DATE,
    SHIP_DATE,
    SHIPPING_PAID,
    SHIPPING_SERVICE,
    TAX_PAID,
    TOTAL_QUANTITY,
    TOTAL_QUANTITY_WITHOUT_ADJUSTMENTS,
    TOTAL_QUANTITY_WITHOUT_ZERODOLLARITEM,
    TOTAL_QUANTITY_WITHOUT_ADJUSTMENTS_AND_ZERODOLLARITEMS,
    TRACKING_NUMBER,
    UNIT_PRICE,
    UPC,
    USERNAME,
    WEIGHT,
  ],
  [RECIPIENT]: [
    RECIPIENT_ADDRESS,
    RECIPIENT_ADDRESS_FULL_COUNTRY,
    RECIPIENT_COMPANY,
    RECIPIENT_EMAIL,
    RECIPIENT_NAME_AND_COMPANY,
    RECIPIENT_NAME,
    RECIPIENT_PHONE,
  ],
  [SHIP_FROM]: [SHIP_FROM_ADDRESS, SHIP_FROM_COMPANY, SHIP_FROM_COUNTRY, SHIP_FROM_NAME],
  [STORE]: [STORE_COMPANY_NAME, STORE_EMAIL, STORE_LOGO, STORE_NAME, STORE_PHONE, STORE_WEBSITE],
};

export const supportedInPackingSlipsOrderItems = {
  [ORDER_SHIPMENT]: [
    ADJUSTMENT,
    AMOUNT_PAID,
    BUYER_NAME,
    CARRIER_FEE,
    CARRIER_NAME,
    CURRENT_DATE,
    CUSTOM_FIELD_1,
    CUSTOM_FIELD_2,
    CUSTOM_FIELD_3,
    DIMENSIONS,
    IMPORT_KEY,
    GIFT_MESSAGE,
    INTERNAL_NOTES,
    ITEMS_TOTAL,
    NOTES_FROM_BUYER,
    NOTES_TO_BUYER,
    ORDER_NUMBER,
    ORDER_DATE,
    ORDER_ID,
    ORDER_TOTAL,
    PACKAGE_TYPE,
    PACKING_SLIP_MESSAGE,
    PAYMENT_DATE,
    REQUESTED_SHIPPING_SERVICE,
    SCAN_ORDER_NUMBER,
    SHIP_BY_DATE,
    SHIP_DATE,
    SHIPPING_PAID,
    SHIPPING_SERVICE,
    TAX_PAID,
    TOTAL_QUANTITY,
    TOTAL_QUANTITY_WITHOUT_ADJUSTMENTS,
    TOTAL_QUANTITY_WITHOUT_ZERODOLLARITEM,
    TOTAL_QUANTITY_WITHOUT_ADJUSTMENTS_AND_ZERODOLLARITEMS,
    TRACKING_NUMBER,
    UNIT_PRICE,
    UPC,
    USERNAME,
    WEIGHT,
  ],
  [PRODUCT]: [
    ASIN,
    EXTENDED_PRICE,
    EXTENDED_PRICE_ZERO,
    FILL_SKU,
    IMAGE_URL,
    ITEM_OPTIONS,
    ITEM_OPTIONS_LINEBREAK,
    ITEM_OPTIONS_WITHOUT_REPLACEMENT,
    ITEM_TITLE,
    MARKETPLACE_ITEM_NUMBER,
    PRODUCT_DESCRIPTION,
    PRODUCT_LOCATION,
    PRODUCT_NAME,
    PRODUCT_SKU,
    QUANTITY,
    SKU,
    WAREHOUSE_LOCATION,
  ],
  [RECIPIENT]: [
    RECIPIENT_ADDRESS,
    RECIPIENT_ADDRESS_FULL_COUNTRY,
    RECIPIENT_COMPANY,
    RECIPIENT_EMAIL,
    RECIPIENT_NAME_AND_COMPANY,
    RECIPIENT_NAME,
    RECIPIENT_PHONE,
  ],
  [SHIP_FROM]: [SHIP_FROM_ADDRESS, SHIP_FROM_COMPANY, SHIP_FROM_COUNTRY, SHIP_FROM_NAME],
  [STORE]: [STORE_COMPANY_NAME, STORE_EMAIL, STORE_LOGO, STORE_NAME, STORE_PHONE, STORE_WEBSITE],
};

export const supportedInEmail = {
  [ORDER_SHIPMENT]: [
    ORDER_NUMBER,
    SHIP_DATE,
    ORDER_DATE,
    BUYER_NAME,
    USERNAME,
    SHIPPING_SERVICE,
    CARRIER_NAME,
    REQUESTED_SHIPPING_SERVICE,
    NOTES_TO_BUYER,
    NOTES_FROM_BUYER,
    CUSTOM_FIELD_1,
    CUSTOM_FIELD_2,
    CUSTOM_FIELD_3,
    GIFT_MESSAGE,
    PAYMENT_DATE,
    TRACKING_NUMBER,
    USPS_ZONE,
    ITEM_LIST,
    ITEM_LIST_IMAGES,
    ITEM_LIST_NOSKU,
    ITEM_LIST_HIDEZERO,
    ITEM_LIST_SHOWOPTIONS,
    ITEM_LIST_EXTERNALID,
    ITEM_LIST_SHOWCOST,
  ],
  [RECIPIENT]: [RECIPIENT_NAME, RECIPIENT_ADDRESS, RECIPIENT_PHONE, RECIPIENT_EMAIL],
  [STORE]: [STORE_NAME, STORE_COMPANY_NAME, STORE_PHONE, STORE_EMAIL, STORE_LOGO, STORE_WEBSITE],
};

export const groupHeadingMessages = defineMessages({
  [STORE]: {
    defaultMessage: 'Store',
    id: 'kbZiRu',
    description: 'editor.fieldReplacements.groupHeadings.store',
  },
  [RECIPIENT]: {
    defaultMessage: 'Recipient',
    id: 'mfNiU5',
    description: 'editor.fieldReplacements.groupHeadings.recipient',
  },
  [ORDER_SHIPMENT]: {
    defaultMessage: 'Order / Shipment',
    id: 'v6LB/l',
    description: 'editor.fieldReplacements.groupHeadings.orderShipment',
  },
  [PRODUCT]: {
    defaultMessage: 'Product',
    id: '7sIRu0',
    description: 'editor.fieldReplacements.groupHeadings.product',
  },
  [SHIP_FROM]: {
    defaultMessage: 'Ship From Location',
    id: '0ZXRNA',
    description: 'editor.fieldReplacements.groupHeadings.shipFrom',
  },
});

export const messages = defineMessages({
  [ADJUSTMENT]: {
    defaultMessage: 'Adjustment',
    id: 'EcCXXP',
    description: 'editor.fieldReplacements.adjustment',
  },
  [AMOUNT_PAID]: {
    defaultMessage: 'Amount Paid',
    id: 'xIlwQB',
    description: 'editor.fieldReplacements.amountPaid',
  },
  [ASIN]: {
    defaultMessage: 'ASIN',
    id: 'WXkiD7',
    description: 'editor.fieldReplacements.ASIN',
  },
  [BUYER_NAME]: {
    defaultMessage: 'Buyer Name',
    id: 'vcC5eW',
    description: 'editor.fieldReplacements.buyerName',
  },
  [CARRIER_FEE]: {
    defaultMessage: 'Carrier Fee',
    id: 'Dx5oQP',
    description: 'editor.fieldReplacements.carrierFee',
  },
  [CARRIER_NAME]: {
    defaultMessage: 'Carrier Name',
    id: 'e3I9Vj',
    description: 'editor.fieldReplacements.carrierName',
  },
  [CURRENT_DATE]: {
    defaultMessage: 'Current Date',
    id: 'HQpa1I',
    description: 'editor.fieldReplacements.currentDate',
  },
  [CUSTOM_FIELD_1]: {
    defaultMessage: 'Custom Field #1',
    id: 'rDebka',
    description: 'editor.fieldReplacements.customField1',
  },
  [CUSTOM_FIELD_2]: {
    defaultMessage: 'Custom Field #2',
    id: 'ZFpfM3',
    description: 'editor.fieldReplacements.customField2',
  },
  [CUSTOM_FIELD_3]: {
    defaultMessage: 'Custom Field #3',
    id: 'R4PZZs',
    description: 'editor.fieldReplacements.customField3',
  },
  [DIMENSIONS]: {
    defaultMessage: 'Dimensions',
    id: 'U+L6u1',
    description: 'editor.fieldReplacements.dimensions',
  },
  [EXTENDED_PRICE]: {
    defaultMessage: 'Extended Price',
    id: 'o6kP4S',
    description: 'editor.fieldReplacements.extendedPrice',
  },
  [EXTENDED_PRICE_ZERO]: {
    defaultMessage: 'Extended Price Zero',
    id: '5GLCsr',
    description: 'editor.fieldReplacements.extendedPriceZero',
  },
  [FILL_SKU]: {
    defaultMessage: 'Fill Sku',
    id: 'U8j6jA',
    description: 'editor.fieldReplacements.fill',
  },
  [GIFT_MESSAGE]: {
    defaultMessage: 'Gift Message',
    id: 'PFmdXR',
    description: 'editor.fieldReplacements.giftMessage',
  },
  [IMAGE_URL]: {
    defaultMessage: 'Image Url',
    id: '+JRwOD',
    description: 'editor.fieldReplacements.imageUrl',
  },
  [IMPORT_KEY]: {
    defaultMessage: 'Import Key',
    id: 'HytWHy',
    description: 'editor.fieldReplacements.importKey',
  },
  [INTERNAL_NOTES]: {
    defaultMessage: 'Internal Notes',
    id: 'eioVCs',
    description: 'editor.fieldReplacements.internalNotes',
  },
  [ITEM_LIST]: {
    defaultMessage: 'Item List',
    id: 'WO0WMX',
    description: 'editor.fieldReplacements.itemList',
  },
  [ITEM_LIST_IMAGES]: {
    defaultMessage: 'Item List IMAGES',
    id: 'h2tiMT',
    description: 'editor.fieldReplacements.itemListImages',
  },
  [ITEM_LIST_NOSKU]: {
    defaultMessage: 'Item List NOSKU',
    id: 'cGF0X7',
    description: 'editor.fieldReplacements.itemListNoSKU',
  },
  [ITEM_LIST_HIDEZERO]: {
    defaultMessage: 'Item List HIDEZERO',
    id: 'Bvc+aq',
    description: 'editor.fieldReplacements.itemListHideZero',
  },
  [ITEM_LIST_SHOWOPTIONS]: {
    defaultMessage: 'Item List SHOWOPTIONS',
    id: 'lEJedN',
    description: 'editor.fieldReplacements.itemListShowOptions',
  },
  [ITEM_LIST_EXTERNALID]: {
    defaultMessage: 'Item List EXTERNALID',
    id: 'vYbKYp',
    description: 'editor.fieldReplacements.itemListExternalId',
  },
  [ITEM_LIST_SHOWCOST]: {
    defaultMessage: 'Item List SHOWCOST',
    id: '9AgFU1',
    description: 'editor.fieldReplacements.itemListShowCost',
  },
  [ITEM_OPTIONS]: {
    defaultMessage: 'Item Options',
    id: '2Zj44W',
    description: 'editor.fieldReplacements.itemOptions',
  },
  [ITEM_OPTIONS_LINEBREAK]: {
    defaultMessage: 'Item Options Linebreak',
    id: '7eVE9P',
    description: 'editor.fieldReplacements.linebreak',
  },
  [ITEM_OPTIONS_WITHOUT_REPLACEMENT]: {
    defaultMessage: 'Item Options Without Replacement',
    id: 'RysWWM',
    description: 'editor.fieldReplacements.noreplace',
  },
  [ITEM_TITLE]: {
    defaultMessage: 'Item Title',
    id: 'T705aw',
    description: 'editor.fieldReplacements.itemTitle',
  },
  [ITEMS_TOTAL]: {
    defaultMessage: 'Items Total',
    id: '5pWjWH',
    description: 'editor.fieldReplacements.itemsTotal',
  },
  [MARKETPLACE_ITEM_NUMBER]: {
    defaultMessage: 'Marketplace Item #',
    id: 'JPsA0s',
    description: 'editor.fieldReplacements.marketplaceItemNumber',
  },
  [NOTES_FROM_BUYER]: {
    defaultMessage: 'Notes from Buyer',
    id: 'BcsLev',
    description: 'editor.fieldReplacements.notesFromBuyer',
  },
  [NOTES_TO_BUYER]: {
    defaultMessage: 'Notes to Buyer',
    id: 'UeVspx',
    description: 'editor.fieldReplacements.notesToBuyer',
  },
  [ORDER_NUMBER]: {
    defaultMessage: 'Order #',
    id: 'RdTfFN',
    description: 'editor.fieldReplacements.orderNumber',
  },
  [ORDER_ID]: {
    defaultMessage: 'Order ID',
    id: 'C7jEAV',
    description: 'editor.fieldReplacements.orderId',
  },
  [ORDER_DATE]: {
    defaultMessage: 'Order Date',
    id: 'Pt+2bp',
    description: 'editor.fieldReplacements.orderDate',
  },
  [ORDER_TOTAL]: {
    defaultMessage: 'Order Total',
    id: 'v78gfS',
    description: 'editor.fieldReplacements.orderTotal',
  },
  [PACKAGE_TYPE]: {
    defaultMessage: 'Package Type',
    id: 'x+vkMH',
    description: 'editor.fieldReplacements.packageType',
  },
  [PACKING_SLIP_MESSAGE]: {
    defaultMessage: 'Packing Slip Message',
    id: 'JwmEzE',
    description: 'editor.fieldReplacements.packingSlipMessage',
  },
  [PAYMENT_DATE]: {
    defaultMessage: 'Payment Date',
    id: 'RVWoJJ',
    description: 'editor.fieldReplacements.paymentDate',
  },
  [PRODUCT_DESCRIPTION]: {
    defaultMessage: 'Product Description',
    id: 'OoSYf3',
    description: 'editor.fieldReplacements.productDescription',
  },
  [PRODUCT_LOCATION]: {
    defaultMessage: 'Product Location',
    id: 'M29M33',
    description: 'editor.fieldReplacements.productLocation',
  },
  [PRODUCT_NAME]: {
    defaultMessage: 'Product Name',
    id: 'UD31Wt',
    description: 'editor.fieldReplacements.productName',
  },
  [PRODUCT_SKU]: {
    defaultMessage: 'Product Sku',
    id: 'CW/23M',
    description: 'editor.fieldReplacements.productSku',
  },
  [QUANTITY]: {
    defaultMessage: 'Quantity',
    id: 'Bq49TB',
    description: 'editor.fieldReplacements.quantity',
  },
  [RECIPIENT_ADDRESS]: {
    defaultMessage: 'Recipient Address',
    id: 'xH7/mh',
    description: 'editor.fieldReplacements.recipientAddress',
  },
  [RECIPIENT_ADDRESS_FULL_COUNTRY]: {
    defaultMessage: 'Recipient Address Full Country',
    id: 'StJhAa',
    description: 'editor.fieldReplacements.recipientAddressFullCountry',
  },
  [RECIPIENT_COMPANY]: {
    defaultMessage: 'Recipient Company',
    id: '0g5DI9',
    description: 'editor.fieldReplacements.recipientCompany',
  },
  [RECIPIENT_EMAIL]: {
    defaultMessage: 'Recipient Email',
    id: 'NtOGbQ',
    description: 'editor.fieldReplacements.recipientEmail',
  },
  [RECIPIENT_NAME]: {
    defaultMessage: 'Recipient Name',
    id: 'xzZEmk',
    description: 'editor.fieldReplacements.recipientName',
  },
  [RECIPIENT_NAME_AND_COMPANY]: {
    defaultMessage: 'Recipient Name And Company',
    id: 'PLVGbK',
    description: 'editor.fieldReplacements.recipientNameAndCompany',
  },
  [RECIPIENT_PHONE]: {
    defaultMessage: 'Recipient Phone',
    id: 'zU76rG',
    description: 'editor.fieldReplacements.recipientPhone',
  },
  [REQUESTED_SHIPPING_SERVICE]: {
    defaultMessage: 'Requested Shipping Service',
    id: '6+dfvf',
    description: 'editor.fieldReplacements.requestedShippingService',
  },
  [SCAN_ORDER_NUMBER]: {
    defaultMessage: 'Scan Order #',
    id: 'j05/RJ',
    description: 'editor.fieldReplacements.scanOrderNumber',
  },
  [SHIP_BY_DATE]: {
    defaultMessage: 'Ship By Date',
    id: 'nFOJs0',
    description: 'editor.fieldReplacements.shipByDate',
  },
  [SHIP_DATE]: {
    defaultMessage: 'Ship Date',
    id: '8WtK2D',
    description: 'editor.fieldReplacements.shipDate',
  },
  [SHIP_FROM_ADDRESS]: {
    defaultMessage: 'Ship From Address',
    id: 'VgE/Dt',
    description: 'editor.fieldReplacements.warehouseAddress',
  },
  [SHIP_FROM_COMPANY]: {
    defaultMessage: 'Ship From Company',
    id: 'BbxYaS',
    description: 'editor.fieldReplacements.warehouseCompany',
  },
  [SHIP_FROM_COUNTRY]: {
    defaultMessage: 'Ship From Country',
    id: 'wPU4jD',
    description: 'editor.fieldReplacements.warehouseCountry',
  },
  [SHIP_FROM_NAME]: {
    defaultMessage: 'Ship From Name',
    id: 'tDZZCE',
    description: 'editor.fieldReplacements.warehouseName',
  },
  [SHIPPING_PAID]: {
    defaultMessage: 'Shipping Paid',
    id: 'om0E5B',
    description: 'editor.fieldReplacements.shippingPaid',
  },
  [SHIPPING_SERVICE]: {
    defaultMessage: 'Shipping Service',
    id: 'gkRtFm',
    description: 'editor.fieldReplacements.shippingService',
  },
  [SKU]: {
    defaultMessage: 'Sku',
    id: 'D+r3km',
    description: 'editor.fieldReplacements.sku',
  },
  [STORE_COMPANY_NAME]: {
    defaultMessage: 'Store Company Name',
    id: 'bcDPlb',
    description: 'editor.fieldReplacements.storeCompanyName',
  },
  [STORE_EMAIL]: {
    defaultMessage: 'Store Email',
    id: 'eNfZaa',
    description: 'editor.fieldReplacements.storeEmail',
  },
  [STORE_LOGO]: {
    defaultMessage: 'Store Logo',
    id: '8T0bCV',
    description: 'editor.fieldReplacements.storeLogo',
  },
  [STORE_NAME]: {
    defaultMessage: 'Store Name',
    id: 'Xhgken',
    description: 'editor.fieldReplacements.storeName',
  },
  [STORE_PHONE]: {
    defaultMessage: 'Store Phone',
    id: 'zjZHi1',
    description: 'editor.fieldReplacements.storePhone',
  },
  [STORE_WEBSITE]: {
    defaultMessage: 'Store Website',
    id: '0wHMCy',
    description: 'editor.fieldReplacements.storeWebsite',
  },
  [TAX_PAID]: {
    defaultMessage: 'Tax Paid',
    id: 'zXWyet',
    description: 'editor.fieldReplacements.taxPaid',
  },
  [TOTAL_QUANTITY]: {
    defaultMessage: 'Total Quantity',
    id: 'Smxhl8',
    description: 'editor.fieldReplacements.totalQuantity',
  },
  [TOTAL_QUANTITY_WITHOUT_ADJUSTMENTS]: {
    defaultMessage: 'Total Quantity Without Adjustments',
    id: '/7VXLJ',
    description: 'editor.fieldReplacements.totalQuantityWithoutAdjustments',
  },
  [TOTAL_QUANTITY_WITHOUT_ADJUSTMENTS_AND_ZERODOLLARITEMS]: {
    defaultMessage: 'Total Quantity Without Adjustments and ZeroDollarItems',
    id: '9fb2tp',
    description: 'editor.fieldReplacements.totalQuantityWithoutAdjustmentsandZeroDollarItems',
  },
  [TOTAL_QUANTITY_WITHOUT_ZERODOLLARITEM]: {
    defaultMessage: 'Total Quantity Without ZeroDollarItem',
    id: 'aoW3lP',
    description: 'editor.fieldReplacements.totalQuantityWithoutZeroDollarItem',
  },
  [TRACKING_NUMBER]: {
    defaultMessage: 'Tracking #',
    id: '3OYnxb',
    description: 'editor.fieldReplacements.trackingNumber',
  },
  [TRACKING_URL]: {
    defaultMessage: 'TrackingUrl',
    id: '/Yrt4u',
    description: 'editor.fieldReplacements.trackingUrl',
  },
  [UNIT_PRICE]: {
    defaultMessage: 'Unit Price',
    id: '0KMsY+',
    description: 'editor.fieldReplacements.unitPrice',
  },
  [USPS_ZONE]: {
    defaultMessage: 'USPS Zone',
    id: 'KPFotp',
    description: 'editor.fieldReplacements.uspsZone',
  },
  [UPC]: {
    defaultMessage: 'UPC',
    id: '7P2LI2',
    description: 'editor.fieldReplacements.upc',
  },
  [USERNAME]: {
    defaultMessage: 'Username',
    id: 'S4TvKT',
    description: 'editor.fieldReplacements.username',
  },
  [WAREHOUSE_LOCATION]: {
    defaultMessage: 'Warehouse Location',
    id: '+Yoou4',
    description: 'editor.fieldReplacements.warehouseLocation',
  },
  [WEIGHT]: {
    defaultMessage: 'Weight',
    id: '5HP7Cl',
    description: 'editor.fieldReplacements.weight',
  },
});

export const mainMessages = defineMessages({
  buttonText: {
    defaultMessage: 'Field Replacements',
    id: 'CwhGmY',
    description: 'editor.fieldReplacements',
  },
  xssError: {
    defaultMessage: 'HTML Contains: {errorMessage}...',
    id: 'Y/FWjP',
    description: 'shown to user when there is an html error',
  },
});

export default messages;
